/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAgentRemoveAgentDelete$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * agent id
 */
  slrId?: number;
}

export function apiAgentRemoveAgentDelete(http: HttpClient, rootUrl: string, params?: ApiAgentRemoveAgentDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentRemoveAgentDelete.PATH, 'delete');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('slrId', params.slrId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentRemoveAgentDelete.PATH = '/api/Agent/RemoveAgent';
